import { render, staticRenderFns } from "./JobModal.yaml?vue&type=template&id=2b94aa48&component"
import script from "./JobModal.yaml?vue&type=script&lang=ts&component"
export * from "./JobModal.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports